import { getTranslatedRoutes } from '~/providers/nuxt-i18n-config-provider';

export default defineNuxtPlugin((nuxtApp) => {
  const customLocalePath = (routeName: string, params) => {
    const localePath  = useLocalePath()
    const locale = useI18n().locale.value;
    const path = localePath({ name: routeName, locale });
    if (routeName && path === '') {

      const allRoutes = getTranslatedRoutes();
      if (Object.keys(allRoutes).length > 0 && Object.prototype.hasOwnProperty.call(allRoutes, routeName)) {
        const path = allRoutes[routeName][locale];
        return setRouteParams(path, params);
      }

      return
    }

    return path;
  };

  const localePathWithAnchor = (routeName: string, anchor: string) => {
    const localePath = useLocalePath()

    const path = localePath(routeName)
    return `${path}#${anchor}`
  };

  const generateProductRouteFromUrl = (url: string) => {
    const routeName = 'p-sport-slug'
    const slug = url.split('/')[3];
    const sport = url.split('/')[2];
    const localePath = useLocalePath();

    return localePath({name: routeName, params: {slug, sport}})
  }

  nuxtApp.provide('customLocalePath', customLocalePath);
  nuxtApp.provide('generateProductRouteFromUrl', generateProductRouteFromUrl);
  nuxtApp.provide('localePathWithAnchor', localePathWithAnchor);
});


const setRouteParams = (path: string, params) => {
  if (!params) {
    return path;
  }

  if (Object.keys(params).length === 0) {
    return path;
  }

  let computedPath = path;
  //eslint-disable-next-line
  const splitPath = path.split(/\/|\-/).filter(Boolean);
  Object.keys(params).forEach((key) => {
    splitPath.forEach((pathItem: string) => {
      if (`[${key}]` === pathItem) {
        if ('null' === params[key] || null === params[key]) {
          computedPath = computedPath.replaceAll(pathItem, '');
        } else {
          computedPath = computedPath.replaceAll(pathItem, params[key]);
        }
      }
    })
  })

  return computedPath;
}
